import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { EncryptionService } from '../../shared/services/encryption/encryption-service.service';
import { firstValueFrom } from 'rxjs';
import { LoadingService } from '../../shared/services/loading/loading.service';
import { WafService } from '@app/shared/services/waf/waf.service';
import { MatDialog } from '@angular/material/dialog';
import { ModalInfoComponent } from '@app/shared/components/modal-info/modal-info.component';
import { GENERAL_ERR_002 } from '@app/shared/constant/general-errors.const';

export const PKeyGuard: CanActivateFn = async () => {
  const encS: EncryptionService = inject(EncryptionService);
  const load: LoadingService = inject(LoadingService);
  const wafLoaderService = inject(WafService);
  const md = inject(MatDialog);
  try{
    const wafKey = await wafLoaderService.ensureWafLoadedAndTokenAvailable();
    const valueKey = await firstValueFrom(encS.getKeyFromGateway());
    if(wafKey && valueKey) return true;
    md.open(ModalInfoComponent, { data: GENERAL_ERR_002 });
    return false;
  } catch {
    md.open(ModalInfoComponent, { data: GENERAL_ERR_002 });
    return false;
  } finally {
    load.reset();
  }
};
